export default __webpack_public_path__ + "static/media/navbar-icon-messages.e1e20ed0.svg";